import { PickingAreasSearchResult } from 'apis/picker-api/types';
import { Item } from 'apis/restaurant-api/merchant-admin/menu2/types';
import { isDefined } from 'common/utils';

import { ListElement, HeaderData, ItemData } from './types';

export const isHeaderType = (el: ListElement): el is HeaderData => el.type === 'header';

export const isItemType = (el: ListElement): el is ItemData => el.type === 'item';

export const filterOrphanHeaders = (el: ListElement, _: number, array: ListElement[]) => {
  const allItemIds = array.filter(isItemType).map(arrayEl => arrayEl.data.id);
  return isItemType(el) || (isHeaderType(el) && allItemIds.some(itemId => el.data.itemIds.includes(itemId)));
};

export const transformSearchResultsToListElements = (
  searchResult: PickingAreasSearchResult,
  menuItems: Item[],
): ListElement[] =>
  searchResult.pickingAreas.flatMap(area => {
    const header = {
      type: 'header' as const,
      data: { id: area.id, name: area.name, itemIds: area.items.map(item => item.id) },
    };
    const items = area.items.map(item => menuItems.find(menuItem => menuItem.id === item.id)).filter(isDefined);
    const itemResults = items.map(item => ({
      type: 'item' as const,
      data: item,
      areaId: area.id,
    }));
    return [header, ...itemResults];
  });
